import { Message } from 'element-ui';
import { cloneDeep } from 'lodash';

const timeout = 10000;
const whiteList = ['plugGetVersion'];

const mesMap = {};
const mesErrorMap = {};

export const callPlug = (mesKey, params = {}) => {
	// 调用插件函数
	if (!window.cytPlugOk) {
		!whiteList.includes(mesKey) && Message.error('未检测到扩展插件，请确认是否已经安装插件并且保持网络畅通');
		throw new Error('未检测到扩展插件，请确认是否已经安装插件并且保持网络畅通');
	}
	const currentKey = mesKey + new Date().valueOf();

	window.postMessage({
		backMesKey: currentKey,
		mesKey,
		sender: 'JS',
		callType: 'JSBack',
		data: params,
	});
	return new Promise((res, rej) => {
		const time = setTimeout(() => {
			Message.error('插件链接超时请重试');
			mesMap[currentKey] = null;
			mesErrorMap[currentKey] = null;
			rej();
		}, timeout);
		mesMap[currentKey] = data => {
			res(data);
			mesMap[currentKey] = null;
			clearTimeout(time);
		};
		mesErrorMap[currentKey] = data => {
			rej(data);
			mesErrorMap[currentKey] = null;
			clearTimeout(time);
		};
	});
};

export const callSign = (...args) => {
	// 注册函数供插件使用
	if (!args.length) {
		return;
	}
	if (args.length == 1 && typeof args[0] != 'function') {
		return console.error('callSign 单参数需要是一个函数');
	}
	if (args.length == 1) {
		const cb = args[0];
		let name = cb.name;

		if (name.includes(' ')) {
			name = name.split(' ')[1];
		}
		return (mesMap[name] = cb);
	}
	mesMap[args[0]] = mesMap[args[1]];
};

export const callDestroy = cbName => {
	// 销毁函数
	let name = cbName || '';
	if (typeof cbName == 'function') {
		name = cbName.name;
		if (name.includes(' ')) {
			name = name.split(' ')[1];
		}
	}
	mesMap[name] = null;
};

window.addEventListener(
	'message',
	async event => {
		if (event.data?.sender == 'JS') {
			return;
		}
		const res = cloneDeep(event.data);
		const { backMesKey, mesKey, callType, code, msg } = res;
		if (callType == 'JSBack' && mesMap[backMesKey]) {
			if (code == 0) {
				const data = res.data || {};
				mesMap[backMesKey](data);
			} else {
				mesErrorMap[backMesKey](res);
				Message.error(msg);
			}
		}

		if (callType == 'plugBack' && mesMap[mesKey]) {
			const backData = await mesMap[mesKey](res);
			const { code = 0, msg = '', data } = backData;
			window.postMessage({
				mesKey,
				backMesKey,
				callType,
				code,
				msg,
				data,
			});
		}
	},
	false,
);
